import { ApiUrls } from '../endpoints';
import api from '../createApiClient';

export const getAllAssignments = async () => {
  try {
    const dataUrl = `${ApiUrls.assignment}/getAllAssignments`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all assignments:', error);
    throw error;
  }
};

export const getAllAssignmentsByIssuerId = async (IssuerID) => {
  try {
    const dataUrl = `${ApiUrls.assignment}/getAllAssignmentsByIssuerId/${IssuerID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all assignments:', error);
    throw error;
  }
};

export const getAssignment = async (AssignmentID) => {
  try {
    const dataUrl = `${ApiUrls.assignment}/getAssignmentById/${AssignmentID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting assignment:', error);
    throw error;
  }
};

export const createAssignment = async (data) => {
  try {
    const dataUrl = `${ApiUrls.assignment}/createAssignment`;
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error creating assignment:', error);
    throw error;
  }
};

export const createAssignmentToUnverifiedUser = async (data) => {
  try {
    const dataUrl = `${ApiUrls.assignment}/createAssignmentToUnverifiedUser `;
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error creating assignment to unverified user:', error);
    throw error;
  }
};

export const updateAssignment = async (data) => {
  try {
    const dataUrl = `${ApiUrls.assignment}/updateAssignmentById`;
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error updating assignment:', error);
    throw error;
  }
};

export const approveBadge = async (AssignmentID) => {
  try {
    const dataUrl = `${ApiUrls.assignment}/approveAssignmentById/${AssignmentID}`;
    const response = await api.post(dataUrl, null,);
    return response.data;
  } catch (error) {
    console.error('Error approving badge:', error);
    throw error;
  }
};

export const deleteAssignment = async (AssignmentID) => {
  try {
    const dataUrl = `${ApiUrls.assignment}/deleteAssignmentById/${AssignmentID}`;
    const response = await api.delete(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error deleting assignment:', error);
    throw error;
  }
};

export const deleteAllAssignments = async () => {
  try {
    const dataUrl = `${ApiUrls.assignment}/deleteAllAssignments`;
    const response = await api.delete(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error deleting all assignment:', error);
    throw error;
  }
};

export const approveBadgeAssignment = async (data) => {
  try {
    const dataUrl = `${ApiUrls.assignment}/approveBadgeAssignment`;
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error approving assignment:', error);
    throw error;
  }
};
